import { h2, paragraph } from "@/styles/typography";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Container = styled.div`
  display: block;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  margin-bottom: 34px;

  @media screen and (max-width: 992px) {
    margin-bottom: 18px;
  }

  .vimeo {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const VimeoWrapper = styled.div`
  position: relative;
  aspect-ratio: 16 / 9;
  width: 100%;
  height: 100%;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 1;
`;
const AwardImage = styled(GatsbyImage)`
  width: 148px;
  position: absolute;
  top: 34px;
  right: 34px;
  animation: rotate 30s linear infinite;

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media screen and (max-width: 992px) {
    width: 72px;
    top: 5px;
    right: 5px;
  }
`;

const Image = styled(GatsbyImage)`
  width: 100%;
  object-fit: cover;
  object-position: center;
  z-index: -1;
  aspect-ratio: 16 / 9;
`;

const TextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const TitleWrapper = styled(h2)`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 692px) {
    display: none;
  }
`;

const Title = styled.span`
  color: ${({ theme }) => theme.colors.softBlack};
`;

const TitleWrapperMobile = styled(h2)`
  display: none;

  @media screen and (max-width: 692px) {
    display: flex;
    flex-direction: column;
    color: ${({ theme }) => theme.colors.softBlack};
    font-size: 16px;
    line-height: 20px;
  }
`;

const TitleTextWrapperMobile = styled.div`
  display: none;

  @media screen and (max-width: 692px) {
    display: flex;
    flex-direction: column;
  }
`;

const Subtitle = styled(paragraph)`
  color: ${({ theme }) => theme.colors.tango};
  font-size: 20px;
  margin-top: 2px;

  @media screen and (max-width: 692px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const SubtitleMobile = styled(paragraph)`
  color: ${({ theme }) => theme.colors.tango} !important;
  text-align: right;
  font-size: 20px;
  margin-top: 2px;
  font-size: 16px;
  line-height: 20px;
`;

const TextWrapper = styled.div`
  text-align: right;
  width: fit-content;
  text-align: right;

  @media screen and (max-width: 692px) {
    display: none;
  }
`;

const TextWrapperMobile = styled.div`
  text-align: right;
  width: fit-content;
  align-items: flex-end;
  margin-top: 2px;
  text-align: right;
  display: flex;
  flex-direction: column;
`;

const Text = styled(paragraph)`
  color: ${({ theme }) => theme.colors.softBlack};
  font-size: 20px;
  margin-top: -2px;

  @media screen and (max-width: 692px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const TextLink = styled(Link)`
  text-decoration: none;
  width: fit-content;
  font-size: 22px;
  p {
    margin: 0;
  }
  @media screen and (max-width: 692px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const TextLinkMobile = styled(Link)`
  color: ${({ theme }) => theme.colors.tango};
  text-align: right;
  text-decoration: none;
  font-size: 16px;
  line-height: 20px;
  width: fit-content;
  font-size: 22px;
  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.tango};
    text-align: right;
  }
`;

const BackgroundVideo = styled.div`
  width: 100%;
  height: 100%;
  aspect-ratio: 16/9;

  video {
    width: 100%;
    aspect-ratio: 16 / 9;
    object-fit: cover;
    object-position: center;
  }
`;

const Video = styled.video``;

const S = {
  Container,
  VimeoWrapper,
  TextContainer,
  Overlay,
  TitleWrapper,
  Title,
  TitleWrapperMobile,
  TitleTextWrapperMobile,
  TextWrapper,
  TextWrapperMobile,
  Image,
  Subtitle,
  SubtitleMobile,
  Text,
  Video,
  AwardImage,
  TextLink,
  TextLinkMobile,
  BackgroundVideo,
};

export default S;
